import _ from "lodash";
import { baseActionEpic, IFetchParams, IRequestAction, IRequestDataAction } from "epics/base-epic";
import { CART_GRID_VIEW } from "constants/action-types";
import siteConfig from "site-config";
import { add as snackbarAdd } from "actions/snackbars";
import { format } from "lib/globalize-util";
import { GridViewColumnState } from "helpers/porduct-collection-types";
import { ICustomView, IPivot } from "reducers/cart-grid-view";
import { IStore } from "reducers";
import { VIEW_MODE } from "types/cart/shipment-review";

interface IResponseCustomView {
    _id: string;
    name: string;
    data: {
        isDefault: boolean;
        columns: Partial<GridViewColumnState>[];
        filters: { [key: string]: any };
        pivot: IPivot;
        viewMode: VIEW_MODE;
    };
}

export const fetchCustomViewsEpic = baseActionEpic<IFetchParams, ICustomView[]>(
    CART_GRID_VIEW.CUSTOM_VIEWS.FETCH,
    ({ payload }) => ({
        method: "GET",
        url: siteConfig.api + payload.url,
    }),
    ({ response }) => [{ type: CART_GRID_VIEW.CUSTOM_VIEWS.SET, payload: _.map(response, formatView) }],
);

export const createCustomViewEpic = baseActionEpic<IFetchParams, ICustomView>(
    CART_GRID_VIEW.CUSTOM_VIEWS.CREATE,
    ({ payload }) => ({
        body: payload.body,
        url: siteConfig.api + payload.url,
        method: "POST",
    }),
    ({ response }, action, store: IStore) => {
        const responseView = formatView(response);
        return [
            {
                type: CART_GRID_VIEW.CUSTOM_VIEWS.SET,
                payload: [...store.cartGridView.customViews, formatView(response)],
            },
            {
                type: CART_GRID_VIEW.UPDATE,
                payload: { activeView: responseView?._id },
                isCrossFrame: true,
            },
            snackbarAdd({
                message: responseView.isDefault
                    ? format("Default view updated.")
                    : format("Custom view |name| created.", {
                          name: responseView.name,
                      }),
            }),
        ];
    },
);

export const updateCustomViewEpic = baseActionEpic<IRequestDataAction, ICustomView>(
    CART_GRID_VIEW.CUSTOM_VIEWS.UPDATE,
    ({ payload }) => ({
        body: payload.body,
        url: siteConfig.api + payload.url,
        method: "PUT",
    }),
    ({ response }, action, store: IStore) => {
        const responseView = formatView(response);
        return [
            {
                type: CART_GRID_VIEW.CUSTOM_VIEWS.SET,
                payload: _.map(store.cartGridView.customViews, (view) =>
                    view._id === responseView._id ? responseView : view,
                ),
            },
            snackbarAdd({
                message: responseView.isDefault
                    ? format("Default view updated.")
                    : format("Custom view |name| updated.", { name: responseView.name }),
            }),
        ];
    },
);

export const removeCustomViewEpic = baseActionEpic<IRequestAction, ICustomView>(
    CART_GRID_VIEW.CUSTOM_VIEWS.DELETE,
    ({ payload }) => ({
        url: siteConfig.api + payload.url,
        method: "DELETE",
    }),
    ({ response }, action, store: IStore) => [
        {
            type: CART_GRID_VIEW.CUSTOM_VIEWS.SET,
            payload: _.filter(store.cartGridView.customViews, ({ _id }) => _id !== response._id),
        },
        snackbarAdd({ message: format("View deleted.") }),
    ],
);

const formatView = (responseView: IResponseCustomView): ICustomView => ({
    ..._.pick(responseView, ["_id", "name"]),
    ...responseView.data,
});
